<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-data-table
                :headers="headers"
                :items="items"
                :items-per-page="10"
                :loading="isLoading"
                item-key="id"
                class="elevation-1 border-transparent"
                :loading-text="$t('loadingPleaseWait')"
                :no-data-text="$t('noData')"
                :footer-props="footerProps"
                :header-props="headerProps"
        >
            <template v-slot:item.contractNumber="props">
                <div >
                    {{ props.item.id }}
                </div>
            </template>
            <template v-slot:item.contractTitle="props">
                <div >
                    {{ props.item.title }}
                </div>
            </template>
            <template v-slot:item.contractDate="props">
                <div >
                    {{ props.item.createdAt }}
                </div>
            </template>
            <template v-slot:item.contractActions="{ item }">
                <div class="d-flex justify-center">
                    <v-btn
                            icon
                            :href="`/download/contract/seller?contractID=${item.id}`"
                            small
                    >
                        <v-icon small class="text--main-yellow">
                            save_alt
                        </v-icon>
                    </v-btn>
                    <v-btn icon small @click="showDeleteSnack(item.id)">
                        <v-icon small>
                            delete
                        </v-icon>
                    </v-btn>
                </div>
            </template>
        </v-data-table>
        <v-snackbar
                color="main--black"
                dark
                v-model="snackOpen"
                top
                v-if="snackDelete"
        >
            {{ $t('delete') }} ?
            <div>
                <v-btn text class="text--main-yellow"  @click="remove">{{ $t('yes') }}</v-btn>
                <v-btn text icon @click="closeSnack">
                    <v-icon color="grey">close</v-icon>
                </v-btn>
            </div>
        </v-snackbar>
    </div>
</template>

<script>
    import AppSnack from '../../../../general/mixins/AppSnack';
    import ContractsService from '../../../../app-front/services/api/ContractsService';

    export default {
        name: "ProfileContractsTable",
        props:['reset'],
        mixins:[AppSnack],
        data() {
            return {
                currentOrder: null,
                expandFields: {},
                headers: [],
                items: [],
                isLoading: false,
                options: {},
                page: 0,
                totalItems: null,
                updatingId: null,
                footerProps: {
                    'items-per-page-text': this.$t('rowsPerPage'),
                    'items-per-page-all-text': this.$t('all'),
                    'page-text': /*this.$t('from')*/ '',
                },
                headerProps: {
                    sortByText: this.$t('sortBy'),
                }
            }
        },
        methods: {
            tableDataHeader() {
                ContractsService.setLocale(this.$store.state.language.appLanguage);
                ContractsService.getTableHeaderData()
                .then(res => {
                    this.headers = res.data.headers.map(item => {
                        item.sortable = false;
                        return item
                    });
                })
                .catch(err => {
                    console.log(err);
                });
            },
            tableData() {
                if (this.isLoading) return false;

                this.isLoading = true;
                ContractsService.getTableData()
                    .then(res => {
                        this.items = res.data;
                        this.isLoading = false;
                        this.$emit('reset-change', false);
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            remove() {
                this.resetSnack();

                const params = {id: this.updatingId};
                ContractsService.remove(params)
                    .then(res => {
                        this.setSuccessSnack();
                        this.setSnackText(this.$t('successfulDeleted'));
                        this.openSnack();
                        this.tableData();
                    })
                    .catch(err => {
                        console.log(err);
                        this.setDeleteSnack();
                        this.setSnackText(this.$t('dataErrorUpdated'));
                        this.openSnack();
                    });

                this.updatingId = null;
            },
            showDeleteSnack(id) {
                this.updatingId = id;
                this.resetSnack();
                this.setDeleteSnack();
                this.setDeleteSnackState();
                this.openSnack();
            },
        },
        created() {
            this.tableDataHeader();
            this.tableData();
        },
        watch: {
            tableData: {
                handler() {
                    this.tableData();
                },

                deep: true
            },
            reset: {
                handler() {
                    this.tableData();
                },

                deep: true
            }
        }
    }
</script>

<style scoped>

</style>
